import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { SliderBase } from '@/components/ui/Slider/SliderBase';
import { getScreenValueOfNumber } from '@/utils/style/config';
const settingOfHasArrow = {
    arrows: true,
    infinite: false,
    responsive: [
        {
            breakpoint: getScreenValueOfNumber('sm') - 1,
            settings: {
                arrows: false,
                slidesToShow: 2,
            },
        },
        {
            breakpoint: getScreenValueOfNumber('md') - 1,
            settings: {
                arrows: false,
                slidesToShow: 4,
            },
        },
        {
            breakpoint: getScreenValueOfNumber('lg') - 1,
            settings: {
                slidesToShow: 3,
            },
        },
        {
            breakpoint: getScreenValueOfNumber('xl') - 1,
            settings: {
                slidesToShow: 4,
            },
        },
    ],
    slidesToScroll: 1,
    slidesToShow: 5,
    variableWidth: true,
};
const settingOfNoArrow = {
    arrows: false,
    infinite: false,
    responsive: [
        {
            breakpoint: getScreenValueOfNumber('sm') - 1,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: getScreenValueOfNumber('md') - 1,
            settings: {
                slidesToShow: 3,
            },
        },
    ],
    slidesToScroll: 1,
    slidesToShow: 4,
    variableWidth: true,
};
const customNextButtonProps = {
    customClassName: '!-right-[56px]',
};
const customPrevButtonProps = {
    customClassName: '!-left-[56px]',
};
/**
 * TOP: 相談できるテーマのスライダー（1行）
 * @param props
 * @returns
 */
export const TopThemeSlider = (props) => {
    const { children, className = '', hasArrow = true } = props;
    return (_jsx("div", Object.assign({ className: clsx(hasArrow && 'md:px-[56px]', className) }, { children: _jsx(SliderBase, Object.assign({ customNextButtonProps: customNextButtonProps, customPrevButtonProps: customPrevButtonProps, setting: hasArrow ? settingOfHasArrow : settingOfNoArrow }, { children: children })) })));
};
